module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"The pagination config could not be saved permanently.":"Die Konfiguration konnte nicht dauerhaft gespeichert werden.","Pagination config saved successfully!":"Konfiguration erfolgreich gespeichert!"}}')
  delete Component.options._Ctor
}
